import { createFileRoute } from '@tanstack/react-router';
import { CampaignDetail } from '@/admin/connect/CampaignDetail';

export const Route = createFileRoute('/admin/connect/campaigns/$campaignId')({
  component: CampaignDetailRoute,
  staticData: { minTier: 'FRONT_END_SUPPORT' },
});

function CampaignDetailRoute() {
  const { campaignId } = Route.useParams();
  return <CampaignDetail campaignId={Number(campaignId)} />;
}
